import { Stack, Text } from '@chakra-ui/react';

interface ProductReviewResponseProps {
  response: string;
}

export function ProductReviewResponse({
  response,
}: ProductReviewResponseProps) {
  return (
    <Stack
      borderRadius="base"
      bg="gray.100"
      px={{ base: '2xs', lg: 'sm' }}
      py="2xs"
      gap="4xs"
    >
      <Text as="h6" size="detail" fontWeight="medium">
        Response from Timeline
      </Text>
      <Text size="body2" color="blackAlpha.700">
        {response}
      </Text>
    </Stack>
  );
}
